



















export default {
  props: {
    selected: { type: Boolean, default: false },
  },
  methods: {
    setDropdownWidth() {
      const toggleBtn = this.$el.querySelector('.dropdown-toggle');
      const dropdown = this.$el.querySelector('.dropdown-menu');
      const borderWidth = 2;
      dropdown.style.minWidth = toggleBtn.clientWidth + borderWidth + 'px';
    },
  },
};
